import React from "react";
import styled from "styled-components";
import { CurrencyState } from "../Context";

function Product({
  product_name,
  product_size,
  product_image,
  product_image_hover,
  price,
  product_url,
  tag_message,
  buttonText,
}) {
  const { symbol, amountBasedOnDollar } = CurrencyState();

  const convertPrice = amountBasedOnDollar * price;
  return (
    <div>
      <ProductBox>
        <a href={product_url} target="_blank">
          <Box>
            <ImageBox
              bgImage={product_image}
              bgImageHover={product_image_hover}
            >
              <Availability>
                <span>
                  <p>{tag_message}</p>
                </span>
              </Availability>
              <Overlay>
                <a href={product_url} target="_blank">
                  <BuyButton>{buttonText}</BuyButton>
                </a>
              </Overlay>
            </ImageBox>
          </Box>
        </a>

        <DetailBox>
          <Details>
            <p>{product_name}</p>
            <span>{product_size}</span>
          </Details>
          <Price>
            <p>
              {symbol} {convertPrice.toFixed(2)}
            </p>
          </Price>
        </DetailBox>
      </ProductBox>
    </div>
  );
}

export default Product;

const ProductBox = styled.div`
  margin-top: 10px;
`;

const Box = styled.div`
  width: 290px;
  height: 350px;
  box-shadow: rgba(99, 99, 99, 0.3) 0px 2px 8px 0px;
  border-radius: 10px;
  overflow: hidden;
  margin: auto;

  @media (max-width: 768px) {
    margin: 0 auto;
  }

  @media (max-width: 821px) {
    margin: 10px auto;
    width: 170px;
    height: 250px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-color: rgba(204, 204, 204, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
`;

const ImageBox = styled.div`
  width: 290px;
  height: 350px;
  position: relative;
  background-image: ${(props) => `url("/products/${props.bgImage}")`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-sizing: border-box;
  }

  &:hover ${Overlay} {
    visibility: visible;
    animation: fade 0.5s ease-in;
  }

  :hover {
    background-image: ${(props) => `url("/products/${props.bgImageHover}")`};
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    transition: all ease 0.5s;
  }

  @media (max-width: 821px) {
    margin: 0 auto;
    width: 170px;
    height: 250px;
    background-image: ${(props) => `url("/products/${props.bgImage}")`};

    :hover {
      background-image: ${(props) => `url("/products/${props.bgImageHover}")`};
    }
  }
`;

const BuyButton = styled.div`
  width: 130px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: whitesmoke;
  color: var(--primary);
  font-weight: bold;
  border-radius: 5px;
  box-shadow: 2px 2px 30px rgba(0, 0, 0, 0.2);
  font-family: "Poppins", sans-serif;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 13px;

  :hover {
    color: white;
    background-color: var(--primary);
    transition: all ease 0.5s;
  }

  @media (max-width: 821px) {
    width: 120px;
    font-size: 13px;
    letter-spacing: 0.5px;
  }
`;

const DetailBox = styled.div`
  width: 290px;
  display: flex;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  box-sizing: border-box;
  margin: 10px auto;

  @media (max-width: 821px) {
    margin: 10px auto;
    background-color: #fff;
    width: 170px;
    height: 60px;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
  }
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  text-transform: uppercase;

  p {
    color: #333;
    margin: 5px 0px;
    font-weight: 600;
    letter-spacing: 0.5px;
    text-align: left;
    text-transform: uppercase;
    font-family: Poppins;
    margin: 10px 0;
    text-transform: uppercase;
  }

  span {
    color: rgba(26, 26, 26, 0.5);
    font-size: 12px;
    text-align: left;
    font-weight: bold;
  }

  @media (max-width: 821px) {
    p {
      font-size: 10px;
      font-weight: bold;
    }

    span {
      display: none;
    }
  }
`;

const Price = styled.div`
  background-color: var(--primary);
  height: 40px;
  width: 70px;
  border-radius: 5px;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    letter-spacing: 0.3px;
    color: #fff;
    font-size: 13px;
    text-align: center;
  }

  @media (max-width: 821px) {
    height: 30px;
    width: 60px;

    p {
      font-size: 10px;
      font-weight: bold;
    }
  }
`;

const Availability = styled.div`
  background-color: #transparent;
  height: 25px;
  width: 70px;
  top: 0;
  left: 0;
  color: var(--primary);
  margin-left: 10px;
  margin-top: 10px;
  border-radius: 5px;
  position: absolute;
  border: 2px solid var(--primary);
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    p {
      font-size: 10px;
      text-transform: uppercase;
      font-weight: bold;
      text-align: center;
    }
  }

  @media (max-width: 821px) {
    span {
      p {
    }
  }
`;
